//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
  data () {
    return {
      filter_labels: [],
      news_categories: [],
      news: [],
      pagination: {
        'base_url'      : '',
        'current_page'  : 0,
        'per_page'      : 4,
        'total_pages'   : 1,
        'total_posts'   : 1,
      },
      category: '',
      language: 'en',
      page: 1,
      pagesBefore: [],
      pagesAfter: [],
    }
  },

  mounted: function() {
    this.getNewsCategories();
    this.getCurrentLanguage();
    this.getFilterLabels();
    this.getPageNumber();
    this.getCurrentCategory();
    this.getNews();

    // Get Selectpicker to function within VueJS
    const $selectpicker = $(this.$el).find('.selectpicker');

    $selectpicker.selectpicker({
      style: 'bs-dropdown',
      size: 10,
      dropupAuto : false,
    });
  },

  updated() {
    $(this.$el).find('.selectpicker').selectpicker('refresh');

    // History API Start
    var that = this;
    window.onpopstate = function() {
      that.storeUriParameters();
      that.getNews();
    }
    // History API End
  },

  methods: {
    // History API Start
    pushHistoryState() {
      window.history.pushState(null, '', '?category=' + this.category);
    },
    // History API End

    // Get URI Parameters Start
    storeUriParameters() {
      var category = this.getAllUrlParams().category;

      if (category) {
        this.category = category;
      } else {
        this.category = '';
      }
    },
    // Get URI Parameters End

    getCurrentLanguage() {
      let that = this;
      var url = window.location.href;

      // By defauly, language is already en, but if url contains /mt/, change this to mt
      if (url.indexOf('/mt/') !== -1) {
        that.language = 'mt';
      }
    },

    calculatePagesBefore(currentPage) {
      let that = this;
      var before = [];
      var i = 0;

      for (i = 1; i < parseInt(currentPage); i++) {
        before.push(i);
      }

      that.pagesBefore = before;
    },

    calculatePagesAfter(currentPage) {
      let that = this;
      var after = [];
      var i = 0;

      for (i = parseInt(currentPage) + 1; i <= that.pagination.total_pages; i++) {
        after.push(i);
      }

      that.pagesAfter = after;
    },

    goToFirstPage() {
      /*
       * After filtering through dropdown, there is a chance that we are on a page number which
       * no longer has posts which can be displayed on it.. 
       * (number of posts < number of pages * posts per page)
       *
       * This will result in empty canvas onb this page
       * To mitigate against, after filtering, redirect user to first page of filtered archive
       * by building a url through vue components and using vanilla window.location()
       *
       * Since we are triggering an extra page load, we need to add an extra check so that
       * if user is already on page 1, we do not needlessly redirect.
       */
      let that = this;

      if (parseInt(that.pagination.current_page) !== 1) {
        window.location.href = that.pagination.base_url + '?category=' + that.category ;
      }
    },

    getNews() {
      let that = this;
      var $pathname = encodeURIComponent(window.location.pathname);

      axios.get('/wp-json/wp/v2/generic-posts?cat=' + that.category
       + '&paged=' + that.page
       + '&postType=news&taxonomy=news_taxonomy&perPage=' + that.pagination.per_page
       + '&returnPath=' + $pathname
       + '&language=' + that.language
      )
      .then(function (response) {
        that.news = response.data.posts;
        that.pagination = response.data.pagination;
      
        // Only calculate previous and following pages after we get pagination details and news articles
        that.calculatePagesBefore(response.data.pagination.current_page);
        that.calculatePagesAfter(response.data.pagination.current_page);
      })
      .catch(function (error) {
        console.log(error);
      });

    },

    hasFeaturedImage(article) {
      if (article.featured_image) {
        return true;
      }

      return false;
    },

    getPageNumber() {
      let that = this;

      if (jQuery('#current-page').data('page')) {
        that.page = jQuery('#current-page').data('page');
      }
    },

    getCurrentCategory() {
      let that = this;

      if (jQuery('#current-category').data('category')) {
        that.category = jQuery('#current-category').data('category');
      }
    },

    getNewsCategories() {
      let that = this;

      axios.get('/wp-json/wp/v2/news_categories')
      .then(function (response) {
        that.news_categories = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    getFilterLabels() {
      let that = this;

      axios.get('/wp-json/wp/v2/filter_labels?language=' + that.language)
      .then(function (response) {
        that.filter_labels = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    // Get URL Parameters: https://www.sitepoint.com/get-url-parameters-with-javascript/
    getAllUrlParams(url) {

      // get query string from url (optional) or window
      var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

      // we'll store the parameters here
      var obj = {};

      // if query string exists
      if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i=0; i<arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split('=');

          // in case params look like: list[]=thing1&list[]=thing2
          var paramNum = undefined;
          var paramName = a[0].replace(/\[\d*\]/, function(v) {
            paramNum = v.slice(1,-1);
            return '';
          });

          // set parameter value (use 'true' if empty)
          var paramValue = typeof(a[1])==='undefined' ? true : a[1];

          // (optional) keep case consistent
          paramName = paramName.toLowerCase();
          paramValue = paramValue.toLowerCase();

          // if parameter name already exists
          if (obj[paramName]) {
            // convert value to array (if still string)
            if (typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]];
            }
            // if no array index number specified...
            if (typeof paramNum === 'undefined') {
              // put the value on the end of the array
              obj[paramName].push(paramValue);
            }
            // if array index number specified...
            else {
              // put the value at that index number
              obj[paramName][paramNum] = paramValue;
            }
          }
          // if param name doesn't exist yet, set it
          else {
            obj[paramName] = paramValue;
          }
        }
      }

      return obj;
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/news.vue